<template>
  <v-tooltip top>
    <template v-slot:activator='{ on }'>
      <v-btn
        v-on='on'
        icon
        small
        @click="$emit('toggleShowArchived')"
      >
        <v-icon
          :color="value ? 'red' : 'grey lighten-1'">mdi-archive</v-icon>
<!--         <v-icon v-if='value' color='red'>mdi-eye-off</v-icon>
        <v-icon v-else color='grey lighten-1'>mdi-eye</v-icon> -->
      </v-btn>
    </template>
    <span>
      {{ tooltipMessage }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'wc-show-archived-button',
  props: {
    value: {
      required: true
    },
    tooltip: {
      required: false,
      default: ''
    },
    showArchivedText: {
      required: false,
      default: 'Show archived'
    },
    hideArchivedText: {
      required: false,
      default: 'Hide archived'
    }
  },
  computed: {
    tooltipMessage () {
      if (this.tooltip) {
        return this.tooltip
      }
      return this.value ? this.hideArchivedText : this.showArchivedText
    }
  }
}
</script>
